export default __webpack_public_path__ + "static/O0276-b36944f4f9dd3eab3fa2256bc1695fed.png";